// extracted by mini-css-extract-plugin
module.exports = {"summary":"styles_summary__32lHS","projectedSwitch":"styles_projectedSwitch__277cw","projectedView":"styles_projectedView__-MBNB","pulse":"styles_pulse__28uPq"};